import { CallbackObject } from 'api/core/get-page-function';
import { GetWarehousesVm } from './get-warehouses.vm';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getWarehouses = async (offset: string, callback: CallbackObject<GetWarehousesVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/warehouse/warehouses`, config);
    callback.success(plainToClass(GetWarehousesVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
